import { Text } from '@betty/moonlight';
import { memo } from 'react';
import { StatusTitleTextProps } from './types';

function StatusTitleText({ locKey }: StatusTitleTextProps) {
  return (
    <Text
      variant="h5"
      color="darkSurfacePrimary"
      locNS="status"
      locKey={locKey}
      textAlign="center"
    />
  );
}

export default memo(StatusTitleText);
